import { ProductName } from '@core/constants';

export default {
  queue: {
    [ProductName.PAC_MA]: () => import('./pac/config/queue'),
    [ProductName.PAC_COM]: () => import('./pac/config/queue'),
    [ProductName.HH]: () => import('./hh/config/queue'),
    [ProductName.DMEPOS_MA]: () => import('./dmepos/config/queue'),
    [ProductName.DMEPOS_MCD]: () => import('./dmepos/config/queue'),
  },
  routing: {
    [ProductName.PAC_MA]: () => import('./pac/config/rules'),
    [ProductName.PAC_COM]: () => import('./pac/config/rules'),
    [ProductName.HH]: () => import('./hh/config/rules'),
    [ProductName.DMEPOS_MA]: () => import('./dmepos/config/rules'),
    [ProductName.DMEPOS_MCD]: () => import('./dmepos/config/rules'),
  },
  metrics: {
    [ProductName.PAC_MA]: () => import('./pac/config/metrics'),
    [ProductName.PAC_COM]: () => import('./pac/config/metrics'),
    [ProductName.HH]: () => import('./hh/config/metrics'),
    [ProductName.DMEPOS_MA]: () => import('./dmepos/config/metrics'),
    [ProductName.DMEPOS_MCD]: () => import('./dmepos/config/metrics'),
  },
};
